import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { OrderToBasketService, CartService, OrderService, ProductService, GungModalService } from 'gung-standard';
import { forkJoin, of } from 'rxjs';
import { first, switchMap, map } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TyloOrderToBasketService extends OrderToBasketService {
  constructor(
    protected cartService: CartService,
    protected orderService: OrderService,
    protected productService: ProductService,
    protected modalService: GungModalService,
    protected translationService: TranslateService
  ) {
    super(cartService, orderService, productService, modalService, translationService);
  }

  public getExcludedProductIds(): string[] {
    return environment.copyToCartExcludedProductIds;
  }

  public async addOrderToBasket(orderId: string): Promise<void> {
    const excluded = this.getExcludedProductIds();
    console.log('addOrderToBasket [excluded]', excluded);

    // check if each product in the order is blocked
    // add the product to the cart only when is not blocked
    this.orderService
      .getOrder(orderId)
      .pipe(
        first(),
        switchMap(order =>
          forkJoin({
            order: of(order),
            blockedProducts: this.productService.getBlockedProducts(order.rows.map(row => row.productId)).pipe(first()),
            productsByIds: this.productService.getProductsByIds(order.rows.map(row => row.productId)).pipe(first())
          })
        ),
        map(({ order, blockedProducts, productsByIds }) => {
          // for (const productId of Object.keys(blockedProducts)) {
          for (const product of productsByIds) {
            const productId = product.id;

            // Enable exclusion of specific product ids, such as freight products
            if (excluded.includes(productId)) {
              console.log('addOrderToBasket [excluded]', productId, excluded.includes(productId));
              continue;
            }

            if (!blockedProducts[productId]) {
              const orderRow = order.rows.find(row => row.productId === productId);
              if (!!orderRow) {
                this.addRows([orderRow]);
              }
            }
          }
        })
      )
      .toPromise();
  }
}
